var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.89 23.58L9.14999 22.61C8.33999 22.39 7.56 22.09 6.84 21.71L6.37 22.6C7.16 23.02 8.00999 23.35 8.89999 23.58H8.89Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.39 6.01001L21.52 6.51001C21.93 7.22001 22.27 7.98001 22.52 8.78001L23.48 8.49001C23.21 7.61001 22.84 6.79001 22.39 6.01001Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.99 22.39L17.49 21.52C16.78 21.93 16.02 22.27 15.22 22.52L15.51 23.48C16.39 23.21 17.21 22.84 17.99 22.39Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.58 15.11L22.61 14.85C22.39 15.66 22.09 16.44 21.71 17.16L22.6 17.63C23.02 16.84 23.35 15.99 23.58 15.11Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.43 22.9C12.96 22.96 12.49 23 12 23C11.64 23 11.29 22.98 10.95 22.95L10.85 23.95C11.23 23.99 11.61 24.01 12 24.01C12.53 24.01 13.05 23.96 13.56 23.9L13.43 22.91V22.9Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30001 20.71C4.64001 20.2 4.03001 19.63 3.51001 18.99L2.73001 19.63C3.31001 20.33 3.97001 20.95 4.69001 21.5L5.30001 20.7V20.71Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71 18.69C20.2 19.35 19.63 19.96 18.99 20.48L19.63 21.26C20.33 20.68 20.95 20.02 21.5 19.3L20.7 18.69H20.71Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.89 10.44L22.9 10.57C22.96 11.04 23 11.51 23 12C23 12.36 22.98 12.71 22.95 13.05L23.95 13.15C23.99 12.77 24.01 12.39 24.01 12C24.01 11.47 23.96 10.95 23.9 10.44H23.89Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.48 2.64H19.49C14.78 -1.15 7.88001 -0.859998 3.51001 3.51C0.260009 6.76 -0.729991 11.4 0.520009 15.51C0.520009 15.51 0.540009 15.57 0.550009 15.6C0.650009 15.93 0.770009 16.25 0.900009 16.57H0.910009C1.12001 17.06 1.34001 17.54 1.61001 17.99L2.48001 17.49C2.08001 16.81 1.76001 16.08 1.52001 15.32C0.330009 11.53 1.22001 7.22 4.22001 4.22C8.16001 0.270002 14.38 -0.0299983 18.69 3.28C19.35 3.79 19.96 4.36 20.48 5L21.26 4.36C20.73 3.72 20.13 3.16 19.48 2.64Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14C11.89 14 11.79 13.98 11.68 13.95L5.73 11.95C5.21 11.77 4.92 11.21 5.1 10.68C5.28 10.16 5.84 9.87001 6.37 10.05L11.74 11.85L17.3 6.30001C17.69 5.91001 18.32 5.91001 18.71 6.30001C19.1 6.69001 19.1 7.32001 18.71 7.71001L12.72 13.7C12.53 13.89 12.27 13.99 12.01 13.99L12 14Z",
    fill: "#5B5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOff);
export default __webpack_public_path__ + "static/media/TimeOff.c60b5f45b993a0c2f85b7db64dcd9f6e.svg";
export { ForwardRef as ReactComponent };